import { Component, OnInit, Output, EventEmitter, Input, AfterViewInit } from '@angular/core';
import { DispatchBoardService } from '../../../shared/services/dispatch-board.service';
import { DispatchesService } from '../../../shared/services/dispatches.service';
import { GlobalsService } from '../../../shared/services/globals.service';
import { DQOIItem } from '../../../shared/models/DQOIItem';
import { SearchTarget } from '../../../shared/enums/SearchTarget';
import { DispatchData } from '@app/cp/shared/models/DispatchData';
import { DQOIService } from '@app/cp/shared/services/DQOI.service';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { CommonValues } from '../../../shared/static/CommonValues';
import { Subscription } from 'rxjs';

@Component({
    selector: 'cp-dqoi-popup',
    templateUrl: './dqoi-popup.component.html',
    styleUrls: ['./dqoi-popup.component.scss'],
    standalone: false
})
export class DqoiPopupComponent implements OnInit {
    private subs_dqoiGetItem: Subscription;
    private internalFeatureFlagSet: {};


    constructor(private svc_globals: GlobalsService, private svc_data: DispatchBoardService, private svc_dispatch: DispatchesService, private svc_dqoi: DQOIService) {
        
    }
    @Input() dispatchData: DispatchData;
    //@Input() dqoiDisplaySettings: DQOIDisplaySettings = null;
    @Output() titleChild = new EventEmitter<string>();
    //@Input() set close(value: boolean) {
    //    if (value == true) {

    //        this.svc_dqoi.clearDQOIItem(this.dqoiItem.index);
    //    }
    //}
//    protected data: DispatchData;
    @Output() itemEvent = new EventEmitter<any>();
    dqoiItem: DQOIItem = null;
    loaderState: boolean = true;
    ngOnInit() {
        this.titleChild.emit((this.svc_globals.user.isZuggitUser && (!this.dispatchData?.dqoiDisplaySettings?.useCPRefData)) ? 'Sales Order' : 'Dispatch');
        this.dispatchData = new DispatchData(this.dispatchData);
        let param: string = this.dispatchData.targetCode + ':' + this.dispatchData.id;

        this.subs_dqoiGetItem = this.svc_dispatch.getDQOIItem(param).subscribe(data => {
            data.searchTarget = this.dispatchData.target;
            if (data.masterJobId && data.masterJobId != CommonValues.Guid_Empty)
                { data.searchTarget = SearchTarget.job; }
            let dataObj: DQOIItem = this.svc_dqoi.addDQOIItem(data);
            this.dqoiItem = dataObj;
            this.itemEvent.emit(this.dqoiItem.index);

            this.loaderState = false;
            if (data.error) {
                //alert('got an error back!');
            }
        });
        //this.svc_dispatch.getDQOIItem('1:' + this.dispatchData.viewDispatch.dispatchId).subscribe(data => {
        //    data.searchTarget = SearchTarget.dispatch;
        //    let dataObj: DQOIItem = this.svc_dqoi.addDQOIItem(data);
        //    this.dqoiItem = dataObj;
        //    this.itemEvent.emit(this.dqoiItem.index);

        //    if (data.error) {
        //        alert('got an error back!');
        //    }
        //});
    }
    ngOnDestroy() {
        CommonFunctions.unsubscribe(this.subs_dqoiGetItem);
    }
    closeWindow(e: any) {
    }
}
